import {isDefined} from "~/lib/helpers/guards";

// usage: EnvConfig("MY_ENV")
export function EnvConfig( varName:string) {

  if( ! registry.hasOwnProperty(varName)){
    console.error(`${varName} is not declared`);
    return void 0;
  }

  return registry[varName];
}

const registry = {
  __DEVELOPMENT__:  getEnvSource("NODE_ENV") === "development",
  AUTH_SERVICE_URL: getEnvSource("VUE_APP_AUTH_SERVICE_URL"),
  SERVER_APP_URL: getEnvSource("VUE_APP_SERVER_APP_URL"),
  WS_SERVER_APP_URL: getEnvSource("VUE_APP_WS_SERVER_APP_URL"),
  FILES_SERVER_URL: getEnvSource("VUE_APP_FILES_SERVER_URL"),
  API_KEY: getEnvSource("VUE_APP_API_KEY"),
  FRONT_URL: getEnvSource("VUE_APP_FRONT_URL"),
  ENABLE_LOGOUT: !! asBool(getEnvSource("VUE_APP_ENABLE_LOGOUT")),
};

function getEnvSource(key:string):any{
  return window[key] ?? process.env[key];
}

function asBool(value: unknown) : boolean {

  if( ! isDefined(value)) return false;

  if( typeof value === "string") {
    return value === "1" || value === "true";
  }

  if( typeof value === "number") {
    return value === 1;
  }

  return false;
}